<script lang="ts" setup>
import { useTranslation } from '@hfc/ui-core';

const { t } = useTranslation();
</script>

<template>
  <div class="text-center text-gray-400 text-sm py-6 hidden md:block">
    <p>{{ t('licenseContent.p1') }}</p>
    <p v-html="t('licenseContent.p2')"></p>
  </div>
</template>
